import React from 'react';
import classNames from 'classnames';

const CarouselPagination = ({ current, total, className, ...props }) => {
  // Position from top, based on index
  const calculateTopPosition = () => {
    return `${(current * 100) / total}%`;
  };

  // Height of each bullet or section
  const calculateHeight = () => {
    return `${100 / total}%`;
  };

  return (
    <div
      className={classNames('carousel-pagination flex h-[80px] items-center', className)}
      role="progressbar"
      aria-label="Progress"
      {...props}
    >
      <div className="relative h-full w-1 overflow-hidden rounded bg-charcoal/50">
        <div
          className="absolute left-0 w-full rounded bg-primary opacity-90 transition-all duration-700"
          style={{ top: calculateTopPosition(), height: calculateHeight() }}
        />
      </div>
    </div>
  );
};

export default CarouselPagination;
